import React from "react";
import LegalDoc from "./LegalDoc";

export default function Terms() {
  const apiBase = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  const url = process.env.REACT_APP_LEGAL_TERMS_URL || (apiBase ? `${apiBase}/public/legal/terms` : "https://storage.googleapis.com/hangrong-legal/legal/terms-latest.md");
  return <LegalDoc title="Terms & Conditions" url={url} />;
}
